import { Injectable } from '@angular/core';
import { Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions } from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';
import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { DataTable } from 'primeng/components/datatable/datatable';

import { PlantMapService } from '../../plantmap/services/plant-map.service';
//import { NceService } from '../../nce/services/nce.service';

import { FileService } from '../../shared/services/file.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { StorageService } from '../../shared/services/storage.service';
import { ErrorService } from '../../shared/services/error.service';
import { ValidationService } from '../../shared/services/validation.service';
import { PopupService } from '../../shared/services/pop-up.service';
import * as XLSX from 'xlsx'; //Kowsalya

@Injectable()
export class ReportService {

    vLoadingStatus: boolean;
    vTotalCustomerPlantmap: number = 0;
    vRegenerateMapStatus: number = 0;
    vDisableButton: boolean = false;

    vPlantLists: Array<{
        plant_record_id: number,
        plant_request_id: string,
        project_title: string,
        create_date: string,
        expiry_date: string,
        updated_date: string,
        location: string,
        a2_amount: string,
        status: string,
        trans_amount: string,
        restricted_area: string,
        check_status: string,
        registration_type: string,
        plant_map_s3_status: number
    }>;

    vHistoryLists: Array<{
        plant_request_id: string,
        project_title: string,
        main_contractor: string,
        transaction_record_id: string,
        purchaser_company_name: string,
        create_date: string,
        updated_date: string,
        create_by: string,
        updated_by: string
    }>;

    constructor(
        private _http: Http,
        private _plantmapService: PlantMapService,
        //private _nceService: NceService,
        private _fileService: FileService,
        private _pageNavigationService: PageNavigationService,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _validationService: ValidationService,
        private _popupService: PopupService
    ) {
        this.vLoadingStatus = false;
        //this.resetPlantMapDetail();
    }


    loadTotalCustomerPlantAdmin(pSearchBy, pFilterBy, pPlantStatus) {
        //this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_USER_TOTAL_PLANTMAP_ADMIN + '?search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pPlantStatus);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    //this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vTotalCustomerPlantmap = vResponseData.data.total_plantmap;
                    resolve();
                },
                (error) => {
                    //this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadPlantmapAdmin(pPageNumber, pPageSize, pSearchBy, pFilterBy, pPlantStatus, pSortorder, pSortfield) {
        //this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_USER_PLANTMAP_ADMIN + '?page_number=' + pPageNumber +
            '&page_size=' + pPageSize + '&search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pPlantStatus
            + '&sortorder=' + pSortorder + '&sortfield=' + pSortfield);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    //this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPlantLists = vResponseData.data.plantmaps;

                    this.vPlantLists.forEach((element, index) => {
                        let tempTransAmount = '';
                        tempTransAmount = 'SGD ' + parseFloat(element.trans_amount).toFixed(2);
                        element.trans_amount = tempTransAmount;
                    });

                    resolve();
                },
                (error) => {
                    //this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadTotalCustomerPlantDateAdmin(pSearchBy, pFromDateFilterBy, pToDateFilterBy, pPlantStatus) {

        console.log("Line 129", pSearchBy, pFromDateFilterBy, pToDateFilterBy, pPlantStatus);
        //this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_USER_TOTAL_PLANTMAP_DATE_ADMIN + '?search_by=' + pSearchBy + '&fromdatefilter_by=' + pFromDateFilterBy + '&todatefilter_by=' + pToDateFilterBy + '&status=' + pPlantStatus);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    //this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vTotalCustomerPlantmap = vResponseData.data.total_plantmap;
                    resolve();
                },
                (error) => {
                    //this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadPlantmapDateAdmin(pPageNumber, pPageSize, pSearchBy, pFromDateFilterBy, pToDateFilterBy, pPlantStatus, pSortorder, pSortfield) {
        //this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_USER_PLANTMAP_DATE_ADMIN + '?page_number=' + pPageNumber +
            '&page_size=' + pPageSize + '&search_by=' + pSearchBy + '&fromdatefilter_by=' + pFromDateFilterBy + '&todatefilter_by=' + pToDateFilterBy + '&status=' + pPlantStatus
            + '&sortorder=' + pSortorder + '&sortfield=' + pSortfield);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    //this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPlantLists = vResponseData.data.plantmaps;

                    this.vPlantLists.forEach((element, index) => {
                        let tempTransAmount = '';
                        tempTransAmount = 'SGD ' + parseFloat(element.trans_amount).toFixed(2);
                        element.trans_amount = tempTransAmount;
                    });

                    resolve();
                },
                (error) => {
                    //this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    getTotalCustomerPlantmap() {
        return this.vTotalCustomerPlantmap;
    }

    getCustomerPlantList() {
        return this.vPlantLists;
    }

    isLoading() {
        return this.vLoadingStatus;
    }
    getRegenerateMapStatus() {
        return this.vRegenerateMapStatus;
    }

    //Kowsalya
    getHistoryExcel(pSearchBy, pFilterBy) {
        this.vLoadingStatus = true;
        this._http.get(API_ENDPOINTS.PLANT_MAP.DOWNLOAD_EXCEL + '?search_by=' + pSearchBy + '&filter_by=' + pFilterBy).subscribe(
            (response) => {
                let vResponseData: any = response;
                console.log("line 191", vResponseData);
                this.vHistoryLists = vResponseData.data;
                console.log("line 193", this.vHistoryLists);
                const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.vHistoryLists);
                const wb: XLSX.WorkBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
                XLSX.writeFile(wb, 'PRP_TransactionHistory.xlsx');
                this.vLoadingStatus = false;
            },
            (error) => {
                console.log(error);
                let vErrorData = error;
                this.vLoadingStatus = false;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    getHistoryExcelBydate(pSearchBy, pFromDateFilterBy, pToDateFilterBy) {
        this.vLoadingStatus = true;
        this._http.get(API_ENDPOINTS.PLANT_MAP.DOWNLOAD_EXCEL_BYDATE + '?search_by=' + pSearchBy + '&fromdatefilter_by=' + pFromDateFilterBy + '&todatefilter_by=' + pToDateFilterBy).subscribe(
            (response) => {
                let vResponseData: any = response;
                console.log("line 215", vResponseData);
                this.vHistoryLists = vResponseData.data;
                console.log("line 217", this.vHistoryLists);
                const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.vHistoryLists);
                const wb: XLSX.WorkBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
                XLSX.writeFile(wb, 'PRP_TransactionHistory.xlsx');
                this.vLoadingStatus = false;
            },
            (error) => {
                console.log(error);
                let vErrorData = error;
                this.vLoadingStatus = false;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }
    //Kowsalya



    gisPlantmapHit(pplant_record_id) {
        this.vLoadingStatus = true;
        let xData = {
            plant_record_id: pplant_record_id,
        };
        // var promise = this._http.post(API_ENDPOINTS.PLANT_MAP.GIS_HIT_ADMIN, xData);
        var promise = this._http.post(API_ENDPOINTS.PLANT_MAP.REGENRATE_PLANTMAP_HIT_ADMIN, xData);
        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    var promise = this._http.post(API_ENDPOINTS.PLANT_MAP.PLANTMAP_REGENERATE_STATUS, xData);
                    let p = new Promise((resolve, reject) => {
                        promise.subscribe(
                            (response) => {
                                this.vRegenerateMapStatus = 1;
                                this.vLoadingStatus = false;
                                console.log(response);
                                this._popupService.openGeneralConfirmationPopup('Notice', 'Request submitted successfully', '', true, false);
                                resolve();
                            },
                            (error) => {
                                this.vRegenerateMapStatus = 0;
                                this.vLoadingStatus = false;
                                console.log(error);
                                let vErrorData = error;
                                this._errorService.setErrorFlag(true);
                                this._popupService.openGeneralConfirmationPopup('Error', vErrorData.code, '', false, false);
                                reject();
                            }
                        );
                    });
                    resolve();
                },
                (error) => {
                    this.vRegenerateMapStatus = 0;
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._popupService.openGeneralConfirmationPopup('Error', vErrorData.code, '', false, false);
                    reject();
                }
            );
        });
        return p;
    }


}



// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/admin/services/report.service.ts